/**
 * angular-admin-oskey-io
 *
 * @license
 * Copyright (c) 2021-2025, OSKEY SAS. All rights reserved.
 *
 * The source code is protected under international copyright law.
 * All rights reserved and protected by the copyright holders.
 *
 * The source code is confidential and only available to authorized individuals with the permission of the copyright holders.
 * If you encounter this source code and do not have permission, please contact the copyright holders and delete this file.
 */

import { ApplicationConfig, ErrorHandler, computed, inject } from '@angular/core';
import { provideRouter, withComponentInputBinding, withViewTransitions } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { OSKTranslateAndHttpProvider } from './core/translate/providers/translateAndHttp.provider';
import { OSKLocaleIdProvider, OSKLocaleInitializer, OSKLocaleService } from '@oskey/locale';
import { OSKFirebaseProvider } from '@oskey/firebase';
import { OSKTitleStrategyProvider } from '@oskey/title-strategy';
import { OSKGlobalErrorHandler } from './core';
import { provideAuth0 } from '@auth0/auth0-angular';
import { environment } from '@env/environment';
import { OSK_UI_LABELS_EN, OSK_UI_LABELS_FR, provideOskUi } from '@oskey/ui';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding(), withViewTransitions()),
    provideAnimationsAsync(),
    OSKTranslateAndHttpProvider,
    OSKLocaleInitializer,
    OSKLocaleIdProvider,
    OSKTitleStrategyProvider,
    OSKFirebaseProvider,
    provideOskUi({
      labels: () => {
        const localeService = inject(OSKLocaleService);
        return computed(() =>
          localeService.locale().startsWith('en') ? OSK_UI_LABELS_EN : OSK_UI_LABELS_FR
        );
      },
      locale: () => {
        const localeService = inject(OSKLocaleService);
        return computed(() => localeService.locale().replace('_', '-'));
      }
    }),
    {
      provide: ErrorHandler,
      useClass: OSKGlobalErrorHandler
    },
    provideAuth0({
      domain: environment.auth0.domain,
      clientId: environment.auth0.clientId,
      authorizationParams: {
        redirect_uri: window.location.origin,
        organization: environment.auth0.organizationId
      }
    })
  ]
};
